<template>
  <overlay-scrollbars :options="{ className: 'custom-scrollbar os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
    <form @submit.prevent="handleSubmit">
      <div class="modal-window-header gray">
        <div class="modal-window-heading">
          <h3 class="icon-heading small">
            <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-contract"></use></svg></span>
            <span v-if="objektlist.length === 1">Flytt 1 objekt til ny kontrakt</span>
            <span v-else>Flytt {{objektlist.length}} objekter til ny kontrakt</span>
          </h3>
        </div>

        <fieldset>
          <div class="grid-x grid-padding-x">
            <TheSelectInput v-model="form.Avdelingsid" containerClassName="cell medium-6" label="Avdeling" name="Avdelingsid" v-validate="'required'" data-vv-validate-on="input" :items="instillinger.avdeling"/>
            <TheSelectInput v-model="form.Kontrakttype" containerClassName="cell medium-6" label="Kontraktstype" name="Kontrakttype" v-validate="'required'" data-vv-validate-on="input" :items="instillinger.kontrakttype"/>

            <div class="cell" v-show="changedAvdeling">
              <div class="panel error">
                <strong>Advarsel:</strong> ved å bytte avdeling vill alle tillhørende ekstra kategorier og underkategorier nullstilles.
              </div>
            </div>
          </div>
        </fieldset>
      </div>

      <div class="modal-window-body">
        <fieldset>
          <div class="grid-x grid-padding-x">
            <TheSelectInput v-model="form.Mottaker" containerClassName="cell medium-6" label="Kontraktansvarlig" name="Mottaker" v-validate="'required'" data-vv-validate-on="input" :items="instillinger.mottaker"/>
            <TheTextInput containerClassName="cell medium-6" symbol="%" label="Salær" name="Salar" v-model.trim="form.Salar" maxlength="10" v-validate="'max:10|decimal'"/>
          </div>
        </fieldset>
      </div>

      <div class="modal-window-footer">
        <div class="grid-x">
          <div class="cell align-right">
            <a v-if="!$store.getters.isFormProcessing" href="javascript:;" @click="closeButtonClick()" class="button primary transparent large modal-close show-for-medium">Avbryt</a>
            <a v-else href="javascript:;" class="button primary transparent large modal-close show-for-medium">Avbryt</a>

            <a v-if="$store.getters.isFormSubmittable" href="javascript:;" @click="submitButtonClick()" class="button primary submit large">Flytt</a>
            <a v-if="$store.getters.isFormProcessing" href="javascript:;" class="button primary submit large loading">Flytter...<span class="loader-spinner"></span></a>
            <a v-if="$store.getters.isFormLoading" href="javascript:;" class="button primary submit large" disabled>Flytt</a>
          </div>
        </div>
      </div>

      <a href="javascript:;" class="modal-close modal-window-close-button" @click="closeButtonClick()">
        <span>Lukk</span>
        <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg>
      </a>
    </form>
  </overlay-scrollbars>
</template>

<script>
// import InstillingerService from '@/services/InstillingerService'
import KontraktService from '@/services/KontraktService'
import KundeService from '@/services/KundeService'
import bus from '@/plugins/event-bus'

export default {
  name: 'KundeKontraktTransferModal',
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    kunde: {
      type: Object,
      required: true
    },
    kontrakt: {
      type: Object,
      required: true
    },
    objektlist: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      form: {},
      instillinger: {
        mottaker: [],
        avdeling: [],
        kontrakttype: [],
        legitimasjon: [],
        expertavdeling: []
      }
    }
  },
  computed: {
    changedAvdeling: function () {
      return parseInt(this.form.Avdelingsid) !== parseInt(this.kontrakt.Avdelingsid)
    }
  },
  created () {
    // Set form not submittable
    this.setFormLoading(true)

    // Make the form object
    this.makeFormItem()

    // Load data needed in the form
    this.fetch()
  },
  methods: {
    makeFormItem: function () {
      // Copy data from kontrakt into form
      this.form = {
        Avdelingsid: this.kontrakt.Avdelingsid,
        Kontrakttype: this.kontrakt.Kontrakttype,
        Mottaker: this.kontrakt.Mottaker,
        Salar: this.kontrakt.Salar
      }

      // Object.assign({}, this.form, this.kontrakt)
    },
    fetch: function () {
      // Add a temp item in all dropdowns, where it show that it is loading...
      this.instillinger.mottaker.unshift({key: this.form.Mottaker, val: 'Laster...'})
      this.instillinger.avdeling.unshift({key: this.form.Avdelingsid, val: 'Laster...'})
      this.instillinger.kontrakttype.unshift({key: this.form.Kontrakttype, val: 'Laster...'})

      KontraktService.loadFormDropdowns()
        .then((data) => {
          this.instillinger.mottaker = data.bruker
          this.instillinger.mottaker.unshift({key: null, val: 'Velg kontraktansvarlig', disabled: true})

          this.instillinger.avdeling = data.avdeling
          this.instillinger.avdeling.unshift({key: null, val: 'Velg avdeling', disabled: true})

          this.instillinger.kontrakttype = data.kontrakttype
          this.instillinger.kontrakttype.unshift({key: null, val: 'Velg kontraktstype', disabled: true})

          // InstillingerService('expertavdeling').dropdown()
          //   .then((response) => {
          //     console.log('Loaded expertavdeling')
          //     console.log(response)
          //     this.instillinger.expertavdeling = response.data
          //   })
        })
        .catch(() => {
          // Skip error
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste ned innstillinger')
        })
        .then(() => {
          this.setFormLoading(false)
        })
    },
    closeButtonClick: function () {
      if (!this.$store.getters.isFormProcessing) {
        this.setFormLoading(false)
        this.$emit('close')
      }
    },
    submitButtonClick: function () {
      this.handleSubmit()
    },
    handleSubmit: function () {
      if (!this.isFormSubmittable()) {
        return
      }

      this.setFormProcessing(true)

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Validation Failed
            this.setFormProcessing(false)
            this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
          } else {
            this.setFormProcessing(true)

            KundeService.moveObjektToNewKontrakt(
              this.kunde.Kundenr,
              this.kontrakt.Kontraktnr,
              this.form,
              this.objektlist
            )
              .then((response) => {
                // Reset selected objekt list and reload list
                bus.$emit('kontrakt-objekter-transferred', response.data.kontrakt)

                // And close modal
                this.closeModal()
              })
              .catch((error) => {
                console.log('Got error: ' + error)
                this.$helpers.showErrorAlert('Feil', 'Kunne ikke flytte objekter.')
              })
              .then(() => {
                this.setFormProcessing(false)
              })
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeKontraktTransferModal.vue